// BackgroundWrapper.tsx
import { BackgroundWrapperProps } from "@/types";
import React from "react";

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({
  children,
  className = ""
}) => {
  return (
    <div
      className={`bg-fp-bg text-white min-w-full min-h-screen ${className}`.trim()}
    >
      {children}
    </div>
  );
};

export default BackgroundWrapper;